import { RootState } from '../store';

export const getModalState = (state: RootState) => state.modal;
